import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../offer-workspace.css";

/**
 * MOD-001 — simple if/then rules for module_graph (dialog-light panel).
 */
export default function ModuleRulesPanel({
  rules = [],
  globals = [],
  nodes = [],
  onChange,
  locked = false,
}) {
  const { t } = useTranslation();
  const list = Array.isArray(rules) ? rules : [];
  const [globalKey, setGlobalKey] = useState(globals[0]?.key || "");
  const [equals, setEquals] = useState("");
  const [nodeId, setNodeId] = useState(nodes[0]?.id || "");
  const [action, setAction] = useState("disable_node");

  const addRule = () => {
    if (locked || !globalKey || !nodeId) return;
    onChange([
      ...list,
      {
        id: `rule-${Date.now()}`,
        when: { global: globalKey, equals },
        then: { action, node_id: nodeId },
      },
    ]);
    setEquals("");
  };

  const removeAt = (index) => onChange(list.filter((_, i) => i !== index));

  return (
    <div className="offer-module-builder__rules mt-4">
      <div className="offer-module-builder__section-kicker">
        {t("offer.calculation.module.rules.title")}
      </div>
      <p className="offer-module-builder__hint">
        {t("offer.calculation.module.rules.hint")}
      </p>
      <ul className="mt-2 space-y-2">
        {list.map((rule, index) => (
          <li
            key={rule.id || index}
            className="rounded border border-slate-200 bg-white p-2 text-xs text-slate-700"
          >
            <div className="flex items-start justify-between gap-2">
              <span>
                {t("offer.calculation.module.rules.summary", {
                  global: rule.when?.global,
                  equals: rule.when?.equals,
                  action: rule.then?.action,
                  node: rule.then?.node_id,
                })}
              </span>
              <button
                type="button"
                className="offer-module-builder__button"
                disabled={locked}
                onClick={() => removeAt(index)}
              >
                {t("offer.calculation.module.globals.remove")}
              </button>
            </div>
          </li>
        ))}
      </ul>
      {!locked ? (
        <div className="mt-2 grid gap-1">
          <select
            className="offer-select"
            value={globalKey}
            onChange={(e) => setGlobalKey(e.target.value)}
          >
            <option value="">{t("offer.calculation.module.rules.pick_global")}</option>
            {(globals || []).map((g) => (
              <option key={g.key} value={g.key}>
                {g.label || g.key}
              </option>
            ))}
          </select>
          <input
            className="rounded border border-slate-300 px-2 py-1 text-sm"
            placeholder={t("offer.calculation.module.rules.equals_placeholder")}
            value={equals}
            onChange={(e) => setEquals(e.target.value)}
          />
          <select
            className="offer-select"
            value={action}
            onChange={(e) => setAction(e.target.value)}
          >
            <option value="disable_node">
              {t("offer.calculation.module.rules.disable_node")}
            </option>
            <option value="enable_node">
              {t("offer.calculation.module.rules.enable_node")}
            </option>
          </select>
          <select
            className="offer-select"
            value={nodeId}
            onChange={(e) => setNodeId(e.target.value)}
          >
            <option value="">{t("offer.calculation.module.rules.pick_node")}</option>
            {(nodes || []).map((n) => (
              <option key={n.id} value={n.id}>
                {n.title || n.id}
              </option>
            ))}
          </select>
          <button
            type="button"
            className="offer-module-builder__button is-primary"
            onClick={addRule}
          >
            {t("offer.calculation.module.rules.add")}
          </button>
        </div>
      ) : null}
    </div>
  );
}
